// THI Cardiovascular Medications List
// Auto-generated from thi-cv-medications-list.csv

export const medications = [
  {
    genericName: 'Adenosine',
    proprietaryName: 'Adenocard',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '3 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Albumin 25%',
    proprietaryName: null,
    containerType: 'bottle',
    containerSize: '100 mL',
    concentration: '25%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Albumin 5%',
    proprietaryName: null,
    containerType: 'bottle',
    containerSize: '250 mL',
    concentration: '5%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Albuterol',
    proprietaryName: 'Ventolin HFA',
    containerType: 'mdi inhaler',
    containerSize: '-',
    concentration: '90 mcg/actuation',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Albuterol',
    proprietaryName: 'Ventolin',
    containerType: 'nebule',
    containerSize: '3 mL',
    concentration: '2.5 mg / 3 mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Aminocaproic Acid',
    proprietaryName: 'Amicar',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '250 mg/mL',
    preparation: 'Draw Up or Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Amiodarone',
    proprietaryName: 'Cordarone',
    containerType: 'vial',
    containerSize: '3 mL',
    concentration: '150 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Bolus: 150 mg over 10 minutes. Infusion: 450 mg in 250 mL, start at 1 mg/min',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Amphotericin B',
    proprietaryName: 'Fungizone',
    containerType: 'vial',
    containerSize: '-',
    concentration: '50 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ampicillin-Sulbactam',
    proprietaryName: 'Unasyn',
    containerType: 'vial',
    containerSize: '-',
    concentration: '3 grams',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Antithrombin III',
    proprietaryName: 'Thrombate',
    containerType: 'vial',
    containerSize: '-',
    concentration: '500 units',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Atropine',
    proprietaryName: null,
    containerType: 'syringe',
    containerSize: '10 mL',
    concentration: '0.1 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Atropine',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '0.4 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 2","CVOR A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Aztreonam',
    proprietaryName: 'Azactam',
    containerType: 'vial',
    containerSize: '-',
    concentration: '2 grams',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Basiliximab',
    proprietaryName: 'Simulect',
    containerType: 'vial',
    containerSize: '-',
    concentration: '20 mg',
    preparation: 'Reconstitute',
    clinicalNotes: 'Reconstitute in 100mL and administer slowly via mini-dripper',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Bivalirudin',
    proprietaryName: 'Angiomax',
    containerType: 'vial',
    containerSize: '-',
    concentration: '250 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["CL A Cart","CL Core","Call Pharmacy"],
    epicOrderRequired: false
  },
  {
    genericName: 'Bupivacaine 0.25% PF',
    proprietaryName: 'Marcaine',
    containerType: 'vial',
    containerSize: '30 mL',
    concentration: '2.5 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Bupivacaine 0.25% PF',
    proprietaryName: 'Marcaine',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '2.5 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Bupivacaine 0.5% PF',
    proprietaryName: 'Marcaine',
    containerType: 'vial',
    containerSize: '30 mL',
    concentration: '5 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Calcium Chloride',
    proprietaryName: null,
    containerType: 'syringe',
    containerSize: '10 mL',
    concentration: '100 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Cefazolin',
    proprietaryName: 'Ancef',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1 gram',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Cefepime',
    proprietaryName: 'Maxipime',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1 gram',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Cefepime',
    proprietaryName: 'Maxipime',
    containerType: 'vial',
    containerSize: '-',
    concentration: '2 grams',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Cefoxitin',
    proprietaryName: 'Mefoxin',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1 gram',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Cefoxitin',
    proprietaryName: 'Mefoxin',
    containerType: 'vial',
    containerSize: '-',
    concentration: '2 grams',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ceftriaxone',
    proprietaryName: 'Rocephin',
    containerType: 'vial',
    containerSize: '-',
    concentration: '2 grams',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ceftriaxone',
    proprietaryName: 'Rocephin',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1 gram',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Cefuroxime',
    proprietaryName: 'Zinacef',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1.5 grams',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Cefuroxime',
    proprietaryName: 'Zinacef',
    containerType: 'vial',
    containerSize: '-',
    concentration: '750 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ciprofloxacin',
    proprietaryName: 'Cipro',
    containerType: 'bag',
    containerSize: '200 mL',
    concentration: '400 mg',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Cisatracurium',
    proprietaryName: 'Nimbex',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '2 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Clevidipine',
    proprietaryName: 'Cleviprex',
    containerType: 'bottle',
    containerSize: '50 mL',
    concentration: '0.5 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: 'Non-formulary request required',
    locations: ["Call Pharmacy"],
    epicOrderRequired: true
  },
  {
    genericName: 'Clevidipine',
    proprietaryName: 'Cleviprex',
    containerType: 'bottle',
    containerSize: '100 mL',
    concentration: '0.5 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: 'Non-formulary request required',
    locations: ["Call Pharmacy"],
    epicOrderRequired: true
  },
  {
    genericName: 'Clindamycin',
    proprietaryName: 'Cleocin',
    containerType: 'bag',
    containerSize: '50 mL',
    concentration: '600 mg',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Clindamycin',
    proprietaryName: 'Cleocin',
    containerType: 'bag',
    containerSize: '50 mL',
    concentration: '900 mg',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Clindamycin',
    proprietaryName: 'Cleocin',
    containerType: 'bag',
    containerSize: '50 mL',
    concentration: '300 mg',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Desmopressin',
    proprietaryName: 'DDAVP',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '4 mcg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Dose: 0.3 mcg/kg. Dilute into 100 mL and administer slowly via mini-dripper',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dexamethasone',
    proprietaryName: 'Decadron',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '4 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dexmedetomidine',
    proprietaryName: 'Precedex',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '100 mcg/mL',
    preparation: 'Draw Up or Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dexmedetomidine Pre-Mix',
    proprietaryName: 'Precedex',
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '4 mcg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dextrose 5%',
    proprietaryName: 'D5W',
    containerType: 'bag',
    containerSize: '50 mL',
    concentration: '5%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dextrose 5%',
    proprietaryName: 'D5W',
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '5%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dextrose 5% in Lactated Ringer\'s Solution',
    proprietaryName: 'D5LR',
    containerType: 'bag',
    containerSize: '1000 mL',
    concentration: '5%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dextrose 5% in Water',
    proprietaryName: 'D50W',
    containerType: 'bag',
    containerSize: '1000 mL',
    concentration: '5%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dextrose 50%',
    proprietaryName: 'D50W',
    containerType: 'syringe',
    containerSize: '50 mL',
    concentration: '25 grams',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Diazepam',
    proprietaryName: 'Valium',
    containerType: 'syringe',
    containerSize: '2 mL',
    concentration: '5 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Digoxin',
    proprietaryName: 'Lanoxin',
    containerType: 'ampul',
    containerSize: '2 mL',
    concentration: '250 mcg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Diltiazem',
    proprietaryName: 'Cardizem',
    containerType: 'vial',
    containerSize: '5 mL',
    concentration: '5 mg/mL',
    preparation: 'Draw Up or Dilute',
    clinicalNotes: 'Bolus dose: 0.25 mg/kg (actual body weight) over 2 minutes. Infusion: 5 to 10 mg/hour; infusion rate may be increased in 5 mg/hour increments according to ventricular response, up to a maximum of 15 mg/hour',
    locations: ["Core Pyxis 1","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Diphenhydramine',
    proprietaryName: 'Benadryl',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '50 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dobutamine',
    proprietaryName: 'Dobutrex',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '12.5 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Infusion: dilute 1000 mg in 250 mL',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dobutamine',
    proprietaryName: 'Dobutrex',
    containerType: 'bag',
    containerSize: '250 mL',
    concentration: '4 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Dopamine',
    proprietaryName: 'Intropin',
    containerType: 'bag',
    containerSize: '250 mL',
    concentration: '800 mg / 250 mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ephedrine PF',
    proprietaryName: 'Emerphed',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '50 mg/mL',
    preparation: 'Draw Up or Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ephedrine PF',
    proprietaryName: 'Emerphed',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '5 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Epinephrine',
    proprietaryName: 'Adrenalin',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '1 mg/mL',
    preparation: 'Draw Up or Dilute',
    clinicalNotes: 'Syringe: dilute to 16 mcg/mL. Infusion: dilute 4 mg in 250 mL (16 mcg/mL)',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Epinephrine',
    proprietaryName: 'Adrenalin',
    containerType: 'syringe',
    containerSize: '10 mL',
    concentration: '0.1 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Epinephrine Pre-Mix',
    proprietaryName: null,
    containerType: 'bag',
    containerSize: '250 mL',
    concentration: '16 mcg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Epoprostenol Arginine (for Inhalation)',
    proprietaryName: 'Velitri, Flolan',
    containerType: 'syringe',
    containerSize: '30 mL',
    concentration: '30 mcg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ertapenem',
    proprietaryName: 'Invanz',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1 gram',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Esmolol',
    proprietaryName: 'Brevibloc',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '10 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Esmolol Infusion',
    proprietaryName: 'Brevibloc',
    containerType: 'bag',
    containerSize: '250 mL',
    concentration: '10 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: 'Infusion: starting dose 25-50 mcg/kg/min. Titrate by 25-50 mcg/kg/min every 5 minutes as needed. Max dose 300 mcg/kg/min',
    locations: ["Core Pyxis 1","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Etomidate',
    proprietaryName: 'Amidate',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '2 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Factor VIIa',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '1 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: 'Mix accoring to package instructions',
    locations: ["Call Pharmacy"],
    epicOrderRequired: false
  },
  {
    genericName: 'Famotidine',
    proprietaryName: 'Pepcid',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '10 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Fat emulsion 20%',
    proprietaryName: 'Nutrilipid, Intralipid',
    containerType: 'bag',
    containerSize: '1000 mL',
    concentration: '20%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Fentanyl',
    proprietaryName: 'Sublimaze',
    containerType: 'vial',
    containerSize: '5 mL',
    concentration: '50 mcg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Fentanyl',
    proprietaryName: 'Sublimaze',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '50 mcg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Fluconazole',
    proprietaryName: 'Diflucan',
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '200 mg',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Fluconazole',
    proprietaryName: 'Diflucan',
    containerType: 'bag',
    containerSize: '200 mL',
    concentration: '400 mg',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Flumazenil',
    proprietaryName: 'Romazicon',
    containerType: 'vial',
    containerSize: '5 mL',
    concentration: '0.1 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Furosemide',
    proprietaryName: 'Lasix',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '10 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Furosemide',
    proprietaryName: 'Lasix',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '10 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Glucagon',
    proprietaryName: 'Glucagen',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '1 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Glycopyrrolate',
    proprietaryName: 'Robinul',
    containerType: 'syringe',
    containerSize: '5 mL',
    concentration: '0.2 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Haloperidol',
    proprietaryName: 'Haldol',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '5 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Heparin',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '5000 units/mL',
    preparation: 'Draw Up',
    clinicalNotes: 'Used for subcutaneous admin and for packing HD catheters',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Heparin',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '1000 units/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Heparin Infusion in D5W',
    proprietaryName: null,
    containerType: 'bag',
    containerSize: '250 mL',
    concentration: '100 units/mL',
    preparation: 'Ready to Use',
    clinicalNotes: 'Typical starting dose: ~17 units/kg/hr',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Heparin PF',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '1000 units/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Hydralazine',
    proprietaryName: 'Apresoline',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '20 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Dilute to 5 mg/mL',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Hydrocortisone',
    proprietaryName: 'Solu-cortef',
    containerType: 'act-o-vial',
    containerSize: '8 mL',
    concentration: '1000 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Hydrocortisone',
    proprietaryName: 'Solu-cortef',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '100 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Hydromorphone',
    proprietaryName: 'Dilaudid',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '2 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Dilute to make 10 mL (0.2 mg/mL)',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Hydromorphone',
    proprietaryName: 'Dilaudid',
    containerType: 'syringe',
    containerSize: '0.5 mL',
    concentration: '0.5 mg',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["CVOR A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ibutilide',
    proprietaryName: 'Corvert',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '0.1 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Administer over 10 minutes',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Indigo carmine (Bludigo)',
    proprietaryName: 'Bludigo',
    containerType: 'ampul',
    containerSize: '5 mL',
    concentration: '8 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Indocyanine Green',
    proprietaryName: 'IC-Green',
    containerType: 'vial',
    containerSize: '-',
    concentration: '25 mg',
    preparation: 'Reconstitute',
    clinicalNotes: 'Reconstitute with 10mL sterile water (2.5 mg/mL). Typical dose 7.5 mg (good to confirm with surgeon first, if unsure). ',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Inhaled nitric oxide',
    proprietaryName: 'iNO',
    containerType: 'inhalational',
    containerSize: '-',
    concentration: '-',
    preparation: 'Ready to Use',
    clinicalNotes: 'Call CVRR Respiratory Therapist for tank. Keep FGF 8-10 LPM on anesthesia machine while running',
    locations: [],
    epicOrderRequired: false
  },
  {
    genericName: 'Insulin Regular',
    proprietaryName: null,
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '1 unit/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Insulin Regular',
    proprietaryName: 'Humulin',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '100 units/mL',
    preparation: 'Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ipratropium-Albuterol',
    proprietaryName: 'Duo-Neb',
    containerType: 'nebule',
    containerSize: '3 mL',
    concentration: '0.5 mg - 3 mg',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Isoproterenol',
    proprietaryName: 'Isuprel',
    containerType: 'bag',
    containerSize: '125 mL',
    concentration: '2 mg / 125 mL',
    preparation: 'Pharmacy Compounds',
    clinicalNotes: 'Note: Cath Lab core stocks this but in the wrong concentration. Need to call pharmacy',
    locations: ["Call Pharmacy"],
    epicOrderRequired: true
  },
  {
    genericName: 'Ketamine',
    proprietaryName: 'Ketalar',
    containerType: 'syringe',
    containerSize: '5 mL',
    concentration: '10 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ketamine Infusion',
    proprietaryName: 'Ketalar',
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '10 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ketorolac',
    proprietaryName: 'Toradol',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '30 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Labetalol',
    proprietaryName: 'Normodyne',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '5 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Lidocaine 0.5% PF',
    proprietaryName: 'Xylocaine',
    containerType: 'vial',
    containerSize: '50 mL',
    concentration: '5 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Lidocaine 1%',
    proprietaryName: 'Xylocaine',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '10 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Lidocaine 2%',
    proprietaryName: 'Xylocaine',
    containerType: 'vial',
    containerSize: '5 mL',
    concentration: '20 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Lidocaine 2%',
    proprietaryName: 'Xylocaine',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '20 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Lidocaine 2%',
    proprietaryName: 'Xylocaine',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '20 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Lidocaine 2% Cardiac',
    proprietaryName: 'Xylocaine',
    containerType: 'syringe',
    containerSize: '5 mL',
    concentration: '20 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Lidocaine 2% PF',
    proprietaryName: 'Xylocaine',
    containerType: 'ampul',
    containerSize: '10 mL',
    concentration: '20 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Lidocaine 2% with Epinephrine 1:100,000',
    proprietaryName: 'Xylocaine-Epi',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '20 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Lidocaine in D5W 0.4% Infusion',
    proprietaryName: 'Xylocaine',
    containerType: 'bag',
    containerSize: '500 mL',
    concentration: '4 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: 'Dose: 1-3 mg/min',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Magnesium Sulfate',
    proprietaryName: null,
    containerType: 'bag',
    containerSize: '50 mL',
    concentration: '2 grams',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Magnesium Sulfate',
    proprietaryName: null,
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '1 gram',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Magnesium Sulfate',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '0.5 grams/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Mannitol 20%',
    proprietaryName: 'Osmitrol',
    containerType: 'bag',
    containerSize: '500 mL',
    concentration: '200 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Mannitol 25%',
    proprietaryName: 'Osmitrol',
    containerType: 'vial',
    containerSize: '50 mL',
    concentration: '12.5 grams',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Meperidine',
    proprietaryName: 'Demerol',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '50 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: 'Use restricted by hospital to patients with rigors/chills. Requires Epic order and call to pharmacy; pharmacy tech will deliver the vial',
    locations: ["Call Pharmacy"],
    epicOrderRequired: true
  },
  {
    genericName: 'Meropenem',
    proprietaryName: 'Merrem',
    containerType: 'vial',
    containerSize: '-',
    concentration: '500 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Meropenem',
    proprietaryName: 'Merrem',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1 gram',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Methylene Blue',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '10 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Dose: 1-2 mg/kg. Mix with 100 mL D5W and administer via mini-dripper. If you mix with NS and put on mini-dripper it will precipitate',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Methylprednisolone',
    proprietaryName: 'Solu-medrol',
    containerType: 'act-o-vial',
    containerSize: '4 mL',
    concentration: '500 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Methylprednisolone',
    proprietaryName: 'Solu-medrol',
    containerType: 'act-o-vial',
    containerSize: '2 mL',
    concentration: '125 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Methylprednisolone',
    proprietaryName: 'Solu-medrol',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1000 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Metoclopramide',
    proprietaryName: 'Reglan',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '5 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Metoprolol',
    proprietaryName: 'Lopressor',
    containerType: 'vial',
    containerSize: '5 mL',
    concentration: '1 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Metronidazole',
    proprietaryName: 'Flagyl',
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '500 mg',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Micafungin',
    proprietaryName: 'Mycamine',
    containerType: 'vial',
    containerSize: '-',
    concentration: '100 mg',
    preparation: 'Reconstitute',
    clinicalNotes: 'Dilute in 100mL, administer slowly via mini-dripper',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Midazolam',
    proprietaryName: 'Versed',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '1 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Midazolam',
    proprietaryName: 'Versed',
    containerType: 'vial',
    containerSize: '5 mL',
    concentration: '1 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["CVOR A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Milrinone',
    proprietaryName: 'Primacor',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '1 mg/mL',
    preparation: 'Draw Up or Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Milrinone',
    proprietaryName: 'Primacor',
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '200 mcg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Morphine',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '10 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Morphine',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '4 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Morphine PF',
    proprietaryName: 'Duramorph',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '0.5 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Mupirocin 2%',
    proprietaryName: 'Bactroban',
    containerType: 'tube',
    containerSize: '-',
    concentration: '22 grams',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Naloxone',
    proprietaryName: 'Narcan',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '0.4 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Dilute to make 10 mL (40 mcg/mL)',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Neostigmine',
    proprietaryName: 'Prostigmine',
    containerType: 'syringe',
    containerSize: '5 mL',
    concentration: '1 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Nicardipine',
    proprietaryName: 'Cardene',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '2.5 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Infusion: dilute 25 mg in 250 mL. Syringe: dilute to 100 mcg/mL or 250 mcg/mL',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Nitroclycerin',
    proprietaryName: 'Tridil',
    containerType: 'bottle',
    containerSize: '250 mL',
    concentration: '200 mcg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Nitroglycerin',
    proprietaryName: 'Tridil',
    containerType: 'syringe',
    containerSize: '10 mL',
    concentration: '100 mcg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Norepinephrine',
    proprietaryName: 'Levophed',
    containerType: 'vial',
    containerSize: '4 mL',
    concentration: '1 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Syringe: 16 mcg/mL. Infusion: 32 mcg/mL (8 mg in 250 mL)',
    locations: ["Core Pyxis 1","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Norepinephrine Pre-Mix',
    proprietaryName: 'Levophed',
    containerType: 'bag',
    containerSize: '250 mL',
    concentration: '32 mcg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ondansetron',
    proprietaryName: 'Zofran',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '2 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Perflutren Lipid Microspheres',
    proprietaryName: 'Definity',
    containerType: 'vial',
    containerSize: '1.5 mL',
    concentration: '-',
    preparation: 'Dilute',
    clinicalNotes: 'Agitate vial at NIC desk, dilute with 8.5 mL NS, administer 1 mL at a time',
    locations: ["Non-Invasive Cardiology Desk"],
    epicOrderRequired: false
  },
  {
    genericName: 'Phenobarbital',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '130 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Phenylephrine',
    proprietaryName: 'Neo-synephrine',
    containerType: 'syringe',
    containerSize: '10 mL',
    concentration: '100 mcg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Phenylephrine',
    proprietaryName: 'Neo-synephrine',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '10 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Dilute 10mg in either 100 mL or 250 mL for infusion',
    locations: ["CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Phytonadione (Vitamin K)',
    proprietaryName: 'Aqua-Mephyton',
    containerType: 'ampul',
    containerSize: '1 mL',
    concentration: '10 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: 'For reversal of anticoagulation: usual dose 10 mg (range 2.5 to 10 mg, depending on the INR and severity of bleeding). Administer as a single dose over 10 to 20 minutes',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Piperacillin-Tazobactam',
    proprietaryName: 'Zosyn',
    containerType: 'vial',
    containerSize: '-',
    concentration: '3.375 grams',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Piperacillin-Tazobactam',
    proprietaryName: 'Zosyn',
    containerType: 'vial',
    containerSize: '-',
    concentration: '2.25 grams',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Potassium Chloride',
    proprietaryName: 'KCl',
    containerType: 'bag',
    containerSize: '50 mL',
    concentration: '10 mEq',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Potassium Chloride',
    proprietaryName: 'KCl',
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '20 mEq',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Povidone-Iodine',
    proprietaryName: 'Betadine',
    containerType: 'bottle',
    containerSize: '118 mL',
    concentration: '-',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Povidone-Iodine Ointment',
    proprietaryName: 'Betadine',
    containerType: 'tube',
    containerSize: '-',
    concentration: '28.35 grams',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Procainamide',
    proprietaryName: 'Pronestryl',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '100 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Loading dose: 20 to 50 mg/minute until a maximum of 17 mg/kg is administered, arrhythmia is controlled, or hypotension occurs. Infusion: dilute to 1000 mg in 250 mL. Infusion dose: 1 to 4 mg/minute',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Promethazine',
    proprietaryName: 'Phenergan',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '25 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Propofol',
    proprietaryName: 'Diprivan',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '10 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Propofol',
    proprietaryName: 'Diprivan',
    containerType: 'bottle',
    containerSize: '100 mL',
    concentration: '10 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Propofol',
    proprietaryName: 'Diprivan',
    containerType: 'bottle',
    containerSize: '50 mL',
    concentration: '10 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Protamine',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '5 mL',
    concentration: '10 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Protamine',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '25 mL',
    concentration: '10 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Prothrombin Complex Concentrate',
    proprietaryName: 'Kcentra',
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '500 units',
    preparation: 'Reconstitute',
    clinicalNotes: 'Mix accoring to package instructions',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Remifentanil',
    proprietaryName: 'Ultiva',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1 mg',
    preparation: 'Dilute',
    clinicalNotes: 'Dilute 1 mg in 100 mL to be compatible with Alaris IV pump drug library',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Rocuronium',
    proprietaryName: 'Zemuron',
    containerType: 'vial',
    containerSize: '5 mL',
    concentration: '10 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ropivacaine 0.2% CADD PF',
    proprietaryName: 'Naropin',
    containerType: 'cassette',
    containerSize: '250 mL',
    concentration: '2 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ropivacaine 0.5% PF',
    proprietaryName: 'Naropin',
    containerType: 'vial',
    containerSize: '30 mL',
    concentration: '5 mg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Dilute to 0.25%',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Ropivacaine-Epinephrine-Clonidine-Ketorolac',
    proprietaryName: 'RECK',
    containerType: 'syringe',
    containerSize: '50 mL',
    concentration: '-',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Scopolamine',
    proprietaryName: 'Transderm',
    containerType: 'patch',
    containerSize: '-',
    concentration: '1.5 mg',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sodium Bicarbonate 8.4%',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '50 mL',
    concentration: '1 mEq/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sodium Bicarbonate 8.4% Infusion',
    proprietaryName: null,
    containerType: 'bag',
    containerSize: '500 mL',
    concentration: '1 mEq/mL',
    preparation: 'Pharmacy Compounds',
    clinicalNotes: '',
    locations: [],
    epicOrderRequired: true
  },
  {
    genericName: 'Sodium Chloride 0.9% NS',
    proprietaryName: 'Normal Saline',
    containerType: 'bag',
    containerSize: '250 mL',
    concentration: '0.90%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sodium Chloride 0.9% NS',
    proprietaryName: 'Normal Saline',
    containerType: 'bag',
    containerSize: '50 mL',
    concentration: '0.90%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sodium Chloride 0.9% NS',
    proprietaryName: 'Normal Saline',
    containerType: 'bag',
    containerSize: '100 mL',
    concentration: '0.90%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sodium Chloride 0.9% NS',
    proprietaryName: 'Normal Saline',
    containerType: 'bag',
    containerSize: '500 mL',
    concentration: '0.90%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sodium Chloride 0.9% NS PF',
    proprietaryName: 'Normal Saline PF',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '0.90%',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sodium nitroprusside',
    proprietaryName: 'Sodium Nipride',
    containerType: 'bag',
    containerSize: '250 mL',
    concentration: '0.2 mg/mL',
    preparation: 'Pharmacy Compounds',
    clinicalNotes: 'Dose: Initially 0.25 to 0.5 mcg/kg/minute; titrate as needed by 0.5 mcg/kg/minute every 5 minutes to achieve desired hemodynamic effect; maximum dose: 10 mcg/kg/minute. Higher doses (eg, 8 to 10 mcg/kg/minute) should only be used for a maximum of 10 minutes to reduce risk of cyanide toxicity',
    locations: ["Call Pharmacy"],
    epicOrderRequired: true
  },
  {
    genericName: 'Sterile Water PF',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '10mL',
    concentration: '-',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sterile Water PF',
    proprietaryName: null,
    containerType: 'vial',
    containerSize: '20 mL',
    concentration: '-',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Succinylcholine',
    proprietaryName: 'Anectine',
    containerType: 'syringe',
    containerSize: '10 mL',
    concentration: '20 mg/mL',
    preparation: 'Ready to Use',
    clinicalNotes: '',
    locations: ["CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sufentanil',
    proprietaryName: 'Sufenta',
    containerType: 'ampul',
    containerSize: '1 mL',
    concentration: '50 mcg/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Dilute to 1 mcg/mL concentration to be compatible with IV pump library',
    locations: ["Core Pyxis 1","Core Pyxis 2"],
    epicOrderRequired: false
  },
  {
    genericName: 'Sugammadex',
    proprietaryName: 'Bridion',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '100 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Tranexamic Acid (TXA)',
    proprietaryName: 'Cyklokapron',
    containerType: 'vial',
    containerSize: '10 mL',
    concentration: '100 mg/mL',
    preparation: 'Draw Up or Dilute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Vancomycin',
    proprietaryName: 'Vancocin',
    containerType: 'vial',
    containerSize: '-',
    concentration: '500 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Vancomycin',
    proprietaryName: 'Vancocin',
    containerType: 'vial',
    containerSize: '-',
    concentration: '1000 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Vasopressin',
    proprietaryName: 'Vasostrict',
    containerType: 'vial',
    containerSize: '1 mL',
    concentration: '20 units/mL',
    preparation: 'Dilute',
    clinicalNotes: 'Dilute to 20 units in 50 mL or 40 units in 100 mL',
    locations: ["Core Pyxis 1","CVOR A Cart","CL Core"],
    epicOrderRequired: false
  },
  {
    genericName: 'Vecuronium',
    proprietaryName: 'Norcuron',
    containerType: 'vial',
    containerSize: '-',
    concentration: '10 mg',
    preparation: 'Reconstitute',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart"],
    epicOrderRequired: false
  },
  {
    genericName: 'Verapamil',
    proprietaryName: 'Isoptin',
    containerType: 'vial',
    containerSize: '2 mL',
    concentration: '2.5 mg/mL',
    preparation: 'Draw Up',
    clinicalNotes: '',
    locations: ["Core Pyxis 1","Core Pyxis 2","CVOR A Cart","CL A Cart","CL Core"],
    epicOrderRequired: false
  }
];

// Total: 180 medications
export default medications;
